// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ouQUoFCx3BrFMD {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  max-width: 224px;
  margin-bottom: 4px;
  padding: 2px;
  gap: 4px;
}
.ouQUoFCx3BrFMD .HEYm1Ov_ImY8UC {
  padding: 2px 4px;
  color: var(--ds-text-subtle, #44546f);
}
.ouQUoFCx3BrFMD .HEYm1Ov_ImY8UC .WXcA233oKnw18g,
.ouQUoFCx3BrFMD .HEYm1Ov_ImY8UC .GLQBRx27plv6Ml {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  margin-bottom: 0;
  color: var(--ds-text-subtle, #44546f);
  font-size: 11px;
  line-height: 12px;
  white-space: nowrap;
}
.ouQUoFCx3BrFMD .HEYm1Ov_ImY8UC .z2ae3SwpOvJT4I {
  display: flex;
  align-items: center;
}
.ouQUoFCx3BrFMD .HEYm1Ov_ImY8UC .GLQBRx27plv6Ml {
  margin-top: 0;
  font-weight: 400;
}
.ouQUoFCx3BrFMD:focus-within {
  outline: none;
}
.xxn4M1UUftrB1r {
  height: 14px;
  border-radius: 6px;
}
.JngbhZPN8uS0Y_ {
  height: 24px;
  border-radius: 8px;
}
.W63ktgHBipZO0h {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.W63ktgHBipZO0h .HEYm1Ov_ImY8UC {
  display: flex;
  flex-direction: column;
}
.W63ktgHBipZO0h .HEYm1Ov_ImY8UC .WXcA233oKnw18g {
  font-weight: 700;
}
.W63ktgHBipZO0h:hover {
  background-color: var(--ds-background-accent-gray-subtlest-hovered, #dcdfe4);
  text-decoration: none;
}
.C4e20YEERyvVOz .HEYm1Ov_ImY8UC {
  display: flex;
}
.C4e20YEERyvVOz .HEYm1Ov_ImY8UC .z2ae3SwpOvJT4I p {
  font-weight: 400;
}
.qAv4ViJSxw64Mi {
  display: none;
  position: relative;
  bottom: 4px;
  max-height: 10px;
}
.RXseEcAq8phG_O {
  display: flex;
  align-items: center;
}
.ouQUoFCx3BrFMD:hover .qAv4ViJSxw64Mi {
  display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mirrorCardBoardChip": `ouQUoFCx3BrFMD`,
	"names": `HEYm1Ov_ImY8UC`,
	"boardNameText": `WXcA233oKnw18g`,
	"listName": `GLQBRx27plv6Ml`,
	"boardName": `z2ae3SwpOvJT4I`,
	"compact": `xxn4M1UUftrB1r`,
	"expanded": `JngbhZPN8uS0Y_`,
	"paid": `W63ktgHBipZO0h`,
	"free": `C4e20YEERyvVOz`,
	"externalLinkIcon": `qAv4ViJSxw64Mi`,
	"boardChipContents": `RXseEcAq8phG_O`
};
export default ___CSS_LOADER_EXPORT___;
